<template>
    <!-- Check partners exist -->

    <div v-if="partners.length !== 0" class="partners-main">
        <div class="partners-title">
            <h3 class="heading center is-underline">Onze Partners</h3>
        </div>
        <!-- Template for partners -->

        <div v-for="partner in partners" :key="partner.id" v-bind:partner="partner" class="partner">
            <prismic-link :field="partner.data.link" class="partner__link link">
                <div class="inner">
                    <prismic-image :field="partner.data.logo" class="inner--img"/>
                    <div class="inner--content">
                        <h3 class="name">{{$prismic.richTextAsPlain(partner.data.title) }}</h3>
                        <span class="client">{{ $prismic.richTextAsPlain(partner.data.partner_client) }}</span>
                    </div>
                </div>
            </prismic-link>
        </div>
    </div>
    <!-- If no partners return message -->
    <div v-else class="partner-main">
        <p>No partners published at this time.</p>
    </div>
</template>

<script>
    export default {
        name: 'partner',
        data() {
            return {
                partners: [],
                linkResolver: this.$prismic.linkResolver
            }
        },
        methods: {
            scrollToTop() {
                window.scrollTo(0, 0);
            },
            getpartners() {
                //Query to get partners
                this.$prismic.client.query(
                    this.$prismic.Predicates.at('document.type', 'partner'),
                    {orderings: '[my.partner.date desc]'}
                ).then((response) => {
                    this.partners = response.results;
                })
            },
            //Function to get the first paragraph of text in a partner and limit the displayed text at 300 characters
            getFirstParagraph(partner) {
                const textLimit = 300;
                const slices = partner.data.body;
                let firstParagraph = '';
                let haveFirstParagraph = false;

                slices.map(function (slice) {
                    if (!haveFirstParagraph) {
                        if (slice.slice_type == "text") {
                            slice.primary.text.forEach(function (block) {
                                if (block.type == "paragraph") {
                                    if (!haveFirstParagraph) {
                                        firstParagraph += block.text;
                                        haveFirstParagraph = true;
                                    }
                                }
                            });
                        }
                    }
                });

                const limitedText = firstParagraph.substr(0, textLimit)

                if (firstParagraph.length > textLimit) {
                    return limitedText.substr(0, limitedText.lastIndexOf(' ')) + '...';
                } else {
                    return firstParagraph;
                }
            },
        },
        created() {
            this.getpartners()
        }
    }
</script>

<style lang="scss">
    .partners-main {
        max-width: 100%;
        margin: auto;
        padding: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        background-color: #ffffff;
        border-radius: 15px 15px 0 0;
        @media (max-width: 768px) {
            border-radius: 15px;
        }
        & .partners-title {
            font-size: 30px;
            width: 100%;
            border-bottom: 0;
            margin: 2rem 0 0;
        }
        & .partner {
            width: 25%;
            /*transition: all .5s;*/
            display: inline-block;
            position: relative;
            overflow: hidden;
            @media (max-width: 768px) {
                width: 50%;
            }
            &__link {
                position: absolute;
                width: calc(100% + 2px);
                height: calc(100% + 2px);
                top: -1px;
                left: -1px;

                &:before {
                    left: 0;
                    width: 100%;
                    position: absolute;
                    content: "";
                    bottom: -1px;
                    height: 50%;
                    /*background: linear-gradient(180deg, transparent 0, transparent 1%, #0f84ca);*/
                    background: linear-gradient(180deg, transparent 0, transparent 1%, #555 );
                    /*background: #000000;*/
                    z-index: 1;
                    opacity: 0;
                    transition: opacity .25s linear;
                }

                & .inner {
                    position: absolute;
                    width: calc(100% + 2px);
                    height: calc(100% + 2px);
                    top: -1px;
                    left: -1px;

                    &--img {
                        width: 60%;
                        padding:20%;
                        position: relative;
                        -webkit-transform: scale(1);
                        -ms-transform: scale(1);
                        transform: scale(1);
                        -webkit-transform-origin: center;
                        -ms-transform-origin: center;
                        transform-origin: center;
                        transition: -webkit-transform 1.5s cubic-bezier(.22, .61, .36, 1);
                        transition: transform 1.5s cubic-bezier(.22, .61, .36, 1);
                        transition: transform 1.5s cubic-bezier(.22, .61, .36, 1),
                        -webkit-transform 1.5s cubic-bezier(.22, .61, .36, 1);
                        background-position: 50%;
                        background-size: cover;
                        background-repeat: no-repeat;
                        filter: grayscale(100%);

                        &:after {
                            content: "";
                            display: block;
                            padding-bottom: 56.2992125984252%;
                        }
                    }

                    &--content {
                        position: absolute;
                        left: 40px;
                        bottom: 40px;
                        color: #fff;
                        padding-left: 17px;
                        z-index: 2;
                        opacity: 0;
                        -webkit-transform: translateY(30px);
                        -ms-transform: translateY(30px);
                        transform: translateY(30px);
                        transition: opacity .25s linear, -webkit-transform .4s ease-out;
                        transition: transform .4s ease-out, opacity .25s linear;
                        transition: transform .4s ease-out, opacity .25s linear, -webkit-transform .4s ease-out;

                        &:before {
                            content: "";
                            position: absolute;
                            top: 2px;
                            left: 0;
                            height: calc(100% + 0px);
                            -webkit-transform: scale(0);
                            -ms-transform: scale(0);
                            transform: scale(0);
                            -webkit-transform-origin: top;
                            -ms-transform-origin: top;
                            transform-origin: top;
                            width: 1px;
                            background-color: #117096;
                            transition: -webkit-transform .6s cubic-bezier(.22, .61, .36, 1) 0s;
                            transition: transform .6s cubic-bezier(.22, .61, .36, 1) 0s;
                            transition: transform .6s cubic-bezier(.22, .61, .36, 1) 0s, -webkit-transform .6s cubic-bezier(.22, .61, .36, 1) 0s;
                        }

                        & .client {

                        }

                        & .meta {
                            color: #9A9A9A;
                            margin-bottom: 8px;
                            font-size: 16px;
                        }

                        & .name {
                            margin: 0;
                            text-transform: uppercase;
                            text-align: left;
                            color: #ffffff;
                        }
                    }
                }

                &:hover {
                    &:before {
                        opacity: 0;
                    }

                    & .inner {
                        &--img {
                            -webkit-filter: none !important;
                            filter: none !important;
                        }
                        &--content {
                            opacity: 0;
                            -webkit-transform: translateY(0);
                            -ms-transform: translateY(0);
                            transform: translateY(0);

                            &:before {
                                -webkit-transform: scale(1);
                                -ms-transform: scale(1);
                                transform: scale(1);
                            }
                        }
                    }
                }
            }

            &:after {
                content: "";
                display: block;
                /*padding-bottom: 56.25%;*/
                padding-bottom: 70%;
                font-size: 24px;
            }
        }
    }

    /* Media Queries */
    @media (max-width: 767px) {
        .partner-main {
            padding: 0;
            margin: 0;
            font-size: 18px;
        }
        .partner-main .partner {
            width: 100%;
            justify-content: space-around;
            flex-basis: 100%;
            margin-bottom: 0;
        }
        .partner-main .partner .partner-inner {
            margin-bottom: 0;
            padding: 15px;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            flex-basis: 100%;
            max-width: 100%;
            width: calc(100% - 15px);
            border-bottom: 2px;
            border-style: groove;
            border-color: rgba(0, 0, 0, 0.1);
        }
    }

</style>
